import { Typography } from '@wishket/design-system';

import { PersonalizedButtonTooltip } from './PersonalizedAreaButton.parts';

import { PATH } from '@/shared/constants';
import { Image } from '@/shared/Components';

interface PersonalizedAreaButtonProps {
  onClick: () => void;
}

const PersonalizedAreaButton = ({ onClick }: PersonalizedAreaButtonProps) => {
  return (
    <button
      className="relative flex h-[50px] items-center gap-2 rounded-full border border-gray-200 pl-2 pr-[15px] hover:border-primary-500"
      onClick={onClick}
    >
      <Image
        className="size-8"
        src={`${PATH.MEDIA_YOZM_IMAGE}/personalized_contents.gif`}
        alt="personalized_contents"
        width={32}
        height={32}
      />
      <Typography variant="body1" className="text-w-gray-600">
        다른 직무 엿보기
      </Typography>
      <PersonalizedButtonTooltip />
    </button>
  );
};

export default PersonalizedAreaButton;
